<div class="content-container col-xs-12">
  <ol class="breadcrumb">
    <li><a href="">{{'global.menu.home' | translate}}</a></li>
    <li><a href="">{{'global.menu.accountt' | translate}}</a></li>
    <li class="active">{{'personalInformation.update' | translate}}</li>
  </ol>

  <div class="content">
    <div class="alert alert-success centertext">
      <a class="close" data-dismiss="alert">×</a> Personal information updated.
    </div>
    <div class="form-content col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3">
      <form class="form-horizontal" [formGroup]="personalInformationForm" (submit)="submitForm($event)">
        <div class="section-label main">
          <h3 class="text-center">Personal Information</h3>
        </div>
        <div class="text-field" [ngClass]="{'has-error': (submitButtonClicked && !getformValue.name.valid)}">
          <input type="text"
                 class="text-input"
                 placeholder=" "
                 #nameInPersionalInformationForm
                 formControlName="name"/>
          <label class="text-input-label">
            {{'personalInformation.form.name' | translate}}
          </label>
          <div class="message"
               *ngIf="submitButtonClicked && !getformValue.name.valid">
            {{'personalInformation.form.error.name' | translate}}
          </div>
        </div>

        <div class="text-field" [ngClass]="{'has-error': (submitButtonClicked && !getformValue.address.valid)}">
          <input type="text"
                 class="text-input"
                 placeholder=" "
                 formControlName="address"/>
          <label class="text-input-label">
            {{'personalInformation.form.address' | translate}}
          </label>
          <div class="message"
               *ngIf="submitButtonClicked && !getformValue.address.valid">
            {{'personalInformation.form.error.address' | translate}}
          </div>
        </div>
        <div class="text-field" [ngClass]="{'has-error': (submitButtonClicked && !getformValue.district.valid)}">
          <input type="text"
                 class="text-input"
                 placeholder=" "
                 formControlName="district"/>
          <label class="text-input-label">
            {{'personalInformation.form.district' | translate}}
          </label>
          <div class="message"
               *ngIf="submitButtonClicked && !getformValue.district.valid">
            {{'personalInformation.form.error.district' | translate}}
          </div>
        </div>
        <div class="text-field" [ngClass]="{'has-error': (submitButtonClicked && !getformValue.province.valid)}">
          <input type="text"
                 class="text-input"
                 placeholder=" "
                 formControlName="province"/>
          <label class="text-input-label">
            {{'personalInformation.form.province' | translate}}
          </label>
          <div class="message"
               *ngIf="submitButtonClicked && !getformValue.province.valid">
            {{'personalInformation.form.error.province' | translate}}
          </div>
        </div>
        <div class="text-field" [ngClass]="{'has-error': (submitButtonClicked && !getformValue.postCode.valid)}">
          <input type="text"
                 class="text-input"
                 placeholder=" "
                 formControlName="postCode"
                 (keyup)="checkNumericInput($event)"/>
          <label class="text-input-label">
            {{'personalInformation.form.postcode' | translate}}
          </label>
          <div class="message"
               *ngIf="submitButtonClicked && !getformValue.postCode.valid">
            {{'personalInformation.form.error.postcode' | translate}}
          </div>
        </div>
        <div class="text-field" [ngClass]="{'has-error': (submitButtonClicked && !getformValue.dateOfBirth.valid)}">
          <input type="text"
                 class="text-input"
                 placeholder=" "
                 tooltip="Date (dd/mm/yyy)"
                 triggers="focus"
                 placement="bottom left"
                 formControlName="dateOfBirth"
                 (keyup)="checkDateOfBirthInput($event)"/>
          <label class="text-input-label">
            {{'personalInformation.form.dateOfBirth' | translate}}
          </label>
          <div class="message"
               *ngIf="submitButtonClicked && !getformValue.dateOfBirth.valid">
            {{'personalInformation.form.error.dateOfBirth' | translate}}
          </div>
        </div>
        <div class="text-field" [ngClass]="{'has-error': (submitButtonClicked && !getformValue.email.valid)}">
          <input type="text"
                 class="text-input"
                 placeholder=" "
                 formControlName="email"/>
          <label class="text-input-label">
            {{'personalInformation.form.email' | translate}}
          </label>
          <div class="message"
               *ngIf="submitButtonClicked && !getformValue.email.valid">
            {{'personalInformation.form.error.email' | translate}}
          </div>
        </div>
        <div class="text-field" [ngClass]="{'has-error': (submitButtonClicked && !getformValue.phoneNumber.valid)}">
          <input type="text"
                 class="text-input"
                 placeholder=" "
                 formControlName="phoneNumber"
                 (keyup)="checkNumericInput($event)"/>
          <label class="text-input-label">
            {{'personalInformation.form.phoneNumber' | translate}}
          </label>
          <div class="message"
               *ngIf="submitButtonClicked && !getformValue.phoneNumber.valid">
            {{'personalInformation.form.error.phoneNumber' | translate}}
          </div>
        </div>
        <div class="button-field" *ngIf="formReadOnly">
          <button class="btn btn-primary btn-edit" (click)="switchReadOnlyStatus(false)">
            {{'personalInformation.form.edit' | translate}}
          </button>
        </div>
        <div class="button-field" *ngIf="!formReadOnly">
          <button type="submit" class="btn btn-primary btn-save">
            {{'personalInformation.form.save' | translate}}
          </button>
        </div>
        <div class="button-field" *ngIf="!formReadOnly">
          <button class="btn btn-default btn-cancel" (click)="cancelFormEditing()">
            {{'personalInformation.form.cancel' | translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
